import React, { useState } from 'react';
import { loginUser } from '../repository/authRepository';

interface LoginProps {
  onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await loginUser(usernameOrEmail, password);
      onLoginSuccess();
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-hero">
          <h2 className="auth-title">Welcome back</h2>
          <p className="auth-subtitle">Sign in to check on your links.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="field-label" htmlFor="usernameOrEmail">Username or Email</label>
            <input
              className="input"
              type="text"
              id="usernameOrEmail"
              value={usernameOrEmail}
              onChange={(e) => setUsernameOrEmail(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label className="field-label" htmlFor="password">Password</label>
            <input
              className="input"
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="alert error">{error}</div>}
          <button className="button" type="submit" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div className="auth-links">
          <a href="/signup">Don't have an account? Sign Up</a>
          <a href="/request-password-reset">Forgot password?</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
